import React from 'react';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { ResponsiveWidthType } from '@fiverr-private/theme/src/components/Box/types';
import { EmptyState } from '../EmptyState/EmptyState';
import ErrorStateImage from '../../assets/error-state.svg';

export const ErrorState = ({ maxWidth }: { maxWidth?: ResponsiveWidthType }) => (
  <EmptyState
    minHeight="60vh"
    title={translate('dynamic_matching.error.title')}
    description={translate('dynamic_matching.error.description')}
    leftButton={
      <Button intent="secondary" variant="outline" onClick={() => window.location.reload()}>
        <I18n k="dynamic_matching.error.refresh" />
      </Button>
    }
    image={<img src={ErrorStateImage} alt="error" width={152} height={130} />}
    {...(maxWidth ? { maxWidth } : {})}
  />
);
